// extracted by mini-css-extract-plugin
module.exports = {"timer":"timer-3veSP","sliding":"sliding-3SPQ_","slideUp":"slideUp-1NDUy","link":"link-1JW0L","sent":"sent-fX2Bc","wait":"wait-1U5P_"};